import { Box, Link, Stack, Typography } from "@mui/material";
import { Component, ErrorInfo, ReactNode } from "react";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "background.default",
            height: "100vh",
            width: "100vw",
          }}
        >
          <Box
            sx={{
              marginBlockStart: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
            }}
          >
            <Box fontSize={150} height={150}>
              <ReportProblemIcon color={"error"} fontSize="inherit" />
            </Box>
            <Typography
              variant="h3"
              textAlign={"center"}
              sx={{
                color: "text.primary",
              }}
            >
              Something went wrong, please try again later
            </Typography>
            <Stack
              color="text.secondary"
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Typography variant="h6" sx={{}}>
                If the problem persists, please contact
              </Typography>
              <Link
                underline="hover"
                component={"a"}
                href="mailto:yinon.e.dev@gmail.co"
                target="_blank"
                rel="noreferrer"
                sx={{
                  color: "primary.main",
                }}
              >
                yinon.e.dev@gmail.com
              </Link>
            </Stack>
          </Box>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
